const LOCAL_STORAGE_WISHLIST_KEY = "wishlist";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";
const GRID_LOADED_CLASS = "loaded";

const selectors = {
  button: "[button-wishlist]",
  grid: "[grid-wishlist]",
  productCard: ".product-card",
};
const hhearts = document.querySelectorAll(".wishlist");
const bhearts = document.querySelectorAll(".prhearts");
const hideproductnotfound = document.getElementById("product-not-found");

document.addEventListener("DOMContentLoaded", () => {
  initButtons();
  initGrid();
  homeWishlist();
});

document.addEventListener("shopify-wishlist:updated", (event) => {
  initGrid();
  if (event.detail.wishlist.length) {
    for (const hheart of hhearts) {
      hheart.classList.add("active");
    }
  } else {
    for (const hheart of hhearts) {
      hheart.classList.remove("active");
    }
  }
});

document.addEventListener("shopify-wishlist:init-product-grid", (event) => {
  if (event.detail.wishlist.length) {
    for (const hheart of hhearts) {
      hheart.classList.add("active");
      hideproductnotfound.style.display = "none";
    }
  } else {
    for (const hheart of hhearts) {
      hheart.classList.remove("active");
      hideproductnotfound.style.display = "block";
    }
  }
});

document.addEventListener("shopify-wishlist:init-buttons", (event) => {
  if (event.detail.wishlist.length) {
    for (const hheart of hhearts) {
      hheart.classList.add("active");
    }
  } else {
    for (const hheart of hhearts) {
      hheart.classList.remove("active");
    }
  }
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, "text/html");
      const productCard = htmlDocument.documentElement.querySelector(
        selectors.productCard
      );
      return productCard.outerHTML;
    })
    .catch((err) =>
      console.error(
        `[Wishlist] Failed to load content for handle: ${handle}`,
        err
      )
    );
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join("");
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent("shopify-wishlist:init-product-grid", {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
    if (wishlistContains(productHandle)) {
      if (bhearts.length) {
        for (const bheart of bhearts) {
          bheart.classList.add("active");
        }
      } else {
        button.classList.add("active");
      }
    }
    button.addEventListener("click", () => {
      updateWishlist(productHandle);
      if (bhearts.length) {
        for (const bheart of bhearts) {
          bheart.classList.toggle("active");
        }
      } else {
        button.classList.toggle("active");
      }
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent("shopify-wishlist:init-buttons", {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  if (array.length) {
    for (const hheart of hhearts) {
      hheart.classList.add("active");
    }
  } else {
    for (const hheart of hhearts) {
      hheart.classList.remove("active");
    }
  }

  const event = new CustomEvent("shopify-wishlist:updated", {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) {
    wishlist.push(handle);
  } else {
    wishlist.splice(indexInWishlist, 1);
  }
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

const homeWishlist = () => {
  const wishlist = getWishlist();
  if (wishlist.length) {
    for (const hheart of hhearts) {
      hheart.classList.add("active");
    }
  } else {
    for (const hheart of hhearts) {
      hheart.classList.remove("active");
    }
  }
};
